var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.mylabel,"id":_vm.id,"items":_vm.items,"error":_vm.error,"error-messages":_vm.error,"attach":"","filled":"","outlined":""},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []

export { render, staticRenderFns }